import Vue from 'vue'
import { compareValues } from '../../../utils'

const getInterviewTrackingIndex = (state, value) => {
  return value.uniqueId
    ? state.interviewTracking.findIndex(
        item => item.jobCodeId === value.jobCodeId && item.uniqueId === value.uniqueId
      )
    : state.interviewTracking.findIndex(item => item.jobCodeId === value.jobCodeId)
}

const mutations = {
  removeSkipButton: (state, value) => {
    let index = state.skipBtn.findIndex(item => item.jobCodeId === value.jobCodeId)
    if (index > -1) state.skipBtn.splice(index, 1)
  },
  addSkipButton: (state, value) => {
    let index = state.skipBtn.findIndex(item => item.jobCodeId === value.jobCodeId)
    if (index === -1) state.skipBtn.unshift(value)
  },
  showLandScapeScreen: (state, value) => {
    state.landscapeScreen = value
  },
  showPotraitScreen: (state, value) => {
    state.potraitScreen = value
  },
  saveCompanyInfo: (state, value) => {
    state.companyInfo = value
  },
  saveRecruiterInfo(state, value) {
    state.recruiterInfo = value
  },
  deleteInterviewData: (state, value) => {
    let index = getInterviewTrackingIndex(state, value)
    if (index > -1) state.interviewTracking.splice(index, 1)
  },
  saveInterviewTrackingData: (state, value) => {
    let index = getInterviewTrackingIndex(state, value)
    if (index === -1) state.interviewTracking.unshift(value)
    else {
      // only increment disconnectCount
      let fData = state.interviewTracking[index]
      let { disconnectCount } = fData
      Vue.set(fData, 'disconnectCount', disconnectCount + 1)
      Vue.set(fData, 'activeQuestionNo', value.activeQuestionNo)
      Vue.set(state.interviewTracking, index, fData)
    }
  },
  quesBox: (state, value) => {
    state.quesBox = value
  },
  videoPercentage: (state, value) => {
    Vue.set(state.videoPercentage, value.fileIndex, {
      percentCompleted: value.percentCompleted
    })
  },
  recordingPercentage: (state, value) => {
    state.recordingPercentage = value
    //Vue.set(state.recordingPercentage, value.questionNo, {percentCompleted: value.percentCompleted})
  },
  uploadProgress: (state, value) => {
    state.uploadProgress = value
  },
  updateJobC: (state, value) => {
    state.updateJobC = value
  },
  publishJobC: (state, value) => {
    state.publishJobC = value
  },
  jobcode: (state, value) => {
    state.jobcode = value
  },
  resetUploadedVideoAnswers: state => {
    state.uploadedVideoAnswers = []
  },
  resetVideoPercentage: state => {
    state.videoPercentage = []
  },
  uploadedVideoAnswers: (state, value) => {
    state.uploadedVideoAnswers = value
    state.uploadedVideoAnswers.sort(compareValues('questionNo', 'asc'))
  },
  trimmedInformation: (state, value) => {
    // resetting
    if (value === null) {
      state.trimmedInformation = []
    }

    // creating/updating
    if (value && value.questionNo) {
      const arr = state.trimmedInformation

      const found = arr.some(a => a.questionNo === value.questionNo)

      if (!found) {
        arr.push(value)
      } else {
        arr.forEach((item, index) => {
          if (item.questionNo === value.questionNo) {
            arr[index].start = value.start
            arr[index].end = value.end
          }
        })
      }
    }
  }
}

export default mutations
